var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMeetballMenu = function SvgMeetballMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MeetballMenu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.333 15.833a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.333 24a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.333 7.667a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MeetballMenu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgMeetballMenu;